<template>
  <div class='popular'>
    <div class="box">
      <div class="title">
          5W2H简单却不简单，吸引主管眼球也可以这样做
        </div>
        <div class="author">
          作者：Jay from 捷思企业管理顾问(深圳)有限公司
        </div>
        <div class="headImg">
          <img :src="headImgUrl" alt="">
        </div>
        <div class="note">
          <div class="text">
            <span>讲话、思维是可以练习的，但是在社会上，很抱歉，可没那么多机会给你重来，一两次在主管和领导面前没表现好，可能就会错失机会。这个技巧帮助你在临场时，可以快速过滤你的思维，避免漏掉重要的环节。平常时候，它亦可以帮助你在跟主管或下属讨论时，能够聚焦重点的一种思考方法，同时这也是执行项目前的先期重要工作。</span>
          </div>
          <div class="text">
            <span class="fontBold">这个诀窍就是：5W2H！</span>
            <span>你没看错，是What、Where、When、Who、Why、How、How much。相信很多人都听过5W2H，可能也觉得老生常谈。可是</span>
            <span class="fontBold">5W2H简单却不简单，</span>
            <span>运用得当，会是你职场上给主管留下好印象的实用技巧。</span>
            <span>这篇文章没有要深入探讨5W2H的各种应用，只是要提供一个简单易用的口诀，使之可以更容易地实践。</span>
            <span>5W2H毕竟是英文，临时用的时候恐会一时脑筋转不过来，所以我们给它冠上</span>
            <span>中文的口诀：事因-人时地-何钱，</span>
            <span>以下一一解说：</span>
          </div>
          <div class="text">
            <div class="fontBold">1)What(事)：</div>
            <div class="fontBold">具体是要做什么事情?</div>
            <span class="fontBold">这是非常非常重要的第一步，</span>
            <span>职场上经常会发生弄错主管的指示，这不仅浪费双方的时间，更会在你以为完成任务时，给主管一个非常恐怖的surprise！所以交办任务当下务必要弄清楚任务的内容，有不明瞭的地方立马提出疑问，宁可在主管交代任务的这个时候多问些问题把事情弄清楚，也好过在事后反复回头咨询主管甚至是最后作错了。弄清楚任务的内容后，</span>
            <span class="fontBold">务必要再复诵你所认知的任务内容给主管听一下，</span>
            <span>让主管确认你所以为的，是他所以为的，通常主管这时候会对你所叙述的内容作个小修改或是再次提醒重点。</span>
          </div>
          <div class="text">
            <div class="fontBold">2)Why(因)：</div>
            <div class="fontBold">做此事的原因、目的为何？要达成什么目标？</div>
            <span>好的主管在交代任务给下属或是跨部门沟通时，会说明任务背后缘由，这有助于取得共识、认同；且</span>
            <span class="fontBold">由于知道目的和具体目标，所以当情况发生变化时，才知道如何应对。</span>
            <span>在三国演义中，曹操大将夏侯惇率大军在博望与刘备对峙，刘备军师诸葛亮在调兵遣将时，任赵云担任前锋与夏侯惇交战，并要求只要输不要赢，赵云纳闷问：「怎讲？」，诸葛亮答：「诱敌深入，将敌军引入博望坡狭谷内」，赵云这才恍然大悟。因为赵云知道了战略目标是将敌军引入狭谷内歼灭，自然也就知道要如何完成他的任务，同时也知道，光打输还不够，还要演得够像，骗敌军追过来，他才算是真正地完成了任务！</span>
            <div>若对于任务背后的原因不解，可询问主管。当然，不见得每个主管都喜欢跟部属透露太多信息，遇到这种情况，也别不识相地打破砂锅问到底，弄清楚要达成的目标是什么就可以了。</div>
          </div>
          <div class="text">
            <span class="fontBold">3)Who(人)：</span>
            <div class="fontBold">自己担任什么角色？负责哪些工作？还有其他利害关系人？</div>
            <div>主管交代任务给你，自然是要你主导，只是有部分工作若没有其他单位积极执行或配合，任务就无法顺利完成，有哪些人会起到积极作用但却是你没把握能控制的，最好这时候提出来。你的主管可能就会另外再跟这些人沟通、交代，甚至是直接召集相关人等再说明一下任务以及各自的工作分工；或许，你也可以跟主管表明你先自行跟他们沟通。由于你有先提出可能的问题，同时也愿意先自行处理看看，主管会觉得你有担当，后续自然也会尽量帮你排除障碍。</div>
            <div>
              若你本身担任主管，在交办任务时，也需要考虑要完成任务，须交代哪些任务给哪些部属，他们工作如何分配，谁为主谁为辅，以及会涉及那些利害关系人，要如何疏通他们，让工作能够顺利进展。基本上，这是一位主管天天都在做和关注的事情。
            </div>
          </div>
          <div class="text">
            <div class="fontBold">4)When(时)：</div>
            <div>是现在马上要办的急事？还是预计何时要展开的工作？完成期限是什么时候？</div>
            <div>我们通常手上会有其他任务在进行，因此要弄清楚此新任务的优先度和完成期限，免得急事缓办，缓事急办。没有时间期限的任务，很有可能会石沉大海，做主管的，也要注意这点。</div>
            <div>另外，也有可能任务事需要事前评估的，评估后可能会有不同的可行方案，这时也需要注明不同方案的所需时间，以及资源和预算等。</div>
          </div>
          <div class="text">
            <div class="fontBold">5)Where(地)：</div>
            <div class="fontBold">任务的范围？试点还是展开？标的是什麼？一定是这里吗？换别的行不行？</div>
            <div>项目和任务须明确界定范围，范围太大的任务很容易失焦，然后发散，所以要确认好具体范围。范围大的项目，也可以拆分为数个范围明确的小项目，分工或按阶段执行。</div>
            <div>另外，主管可能会指定标的，若觉此标的不易实施，也可确认是否可变更标的。领导者日理万机，细节处他不会比你清楚，针对你熟悉的业务，你可以积极提出你的建议，尤其是心中若有一闪而过的不妥，要相信自己在工作岗位上经年累月所磨练出的直觉。</div>
          </div>
          <div class="text">
            <div class="fontBold">6)How(何)：</div>
            <div>如何做？有哪些方案可行？自己的建议是？</div>
            <div>事前或事后讨论皆可提出，事前若心中已有浮现可行的方案，可斟酌提出跟主管讨论，好处是可当场裁决并取得共识。针对需要进一步规划方案的任务，在事后提案时，须提出各种各行的方案，评价各方案的优缺点和所需时间、预算和资源等，以供主管裁决。</div>
            <span class="fontBold">人都是喜欢自己选择的，尤其是主管更享有支配和决策权，</span>
            <span>只提一个方案比较不妥，主管随随便便就可以提出几种可能，然后让你回去重新评估。但是你自己也得有想法，因为主管也会问你建议哪个方案？根据是？因此让你提多个方案不是教你把责任丢给主管，而是展现你是经过多方面审慎评估和比较之后，才给出这个建议。</span>
          </div>
          <div class="text">
            <div class="fontBold">7)How much(钱)</div>
            <div class="fontBold">所需预算？资源？回收效益如何？</div>
            <div class="fontBold">钱确实是主管们心中最关心的事情之一，</div>
            <span>除非你的主管就有决策权，否则他也是要说服他的上司后，才有机会拿到预算。所以有关钱的事，尽早让你的主管知道，也才能尽早知道上面的态度。计划规划了老半天，最后因为预算的问题而遭到搁置，这种事情层出不穷，说实在的也难以杜绝。但是我们做事情的，还是得做好拿捏，各项方案的投资和回收评估一定要做，并掌控好后续的资金流向。</span>
          </div>
          <div class="text">
            <span>以上是</span>
            <span class="fontBold">5W2H：事因-人时地-何钱</span>
            <span>的一一说明，顺序有考虑过思考逻辑和方便背诵，但读者未必只能照这个顺序来理解和记忆。无论你是领导或被领导，这个思考方式都对你有帮助，也不需要你弄懂太复杂的理论，所以非常实用，</span>
            <span class="fontBold">天天都能够在工作和生活上实践，简单却不简单。</span>
          </div>
          <div class="text">
            <div>最后，再提醒一下。领导召开完会议后，通常会再问一句：大家还有没有问题？这时你若能提出领导应该说明但可能疏漏的事情，或是大家都没考虑到的环节，对你会有加分，并且给人思考缜密、面面俱到的印象。但是记得提问时可别咄咄逼人的语气，那可是会招人厌恶的。</div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {
  },
  data () {
    return {
      headImgUrl: require('../../assets/img/article2.png')
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.popular{
  text-align: center;
  text-justify: newspaper;
  text-align: justify;
  margin-bottom: 4rem;
  font-size: 24px;
  line-height: 48px;
}
.popular .box{
  width: 90%;
}
.popular .box{
  margin: 0 auto;
}
.popular .box .title{
  font-weight: bold;
  font-size: 34px;
  margin: 16px 0px;
}
.popular .box .author{
  margin: 16px 0px;
  font-size: 16px;
}
.popular .box .note{
  text-indent: 0;
}
.popular .box .note .text{
  margin-top: 40px;
}
@media screen and (max-width: 1200px){
}
@media screen and (max-width: 992px){
  .popular{
    font-size: 20px;
  }
  .popular .box .title{
    font-size: 30px;
  }
}
@media screen and (max-width: 767px){
}
@media screen and (max-width: 450px){
  .popular .box .author{
    font-size: 12px;
  }
  .popular{
    font-size: 16px;
    line-height: 32px;
  }
    .popular .box .title{
    font-size: 24px;
  }
  .popular .box .note .text{
    margin-top: 20px;
  }
}
</style>
